const style = (theme) => {
  const output = {
    root: {
      color: theme.colors[0],
    },
    page: {
      position: 'relative',
    },
    wrapper: {
      position: 'relative',
      zIndex: 1,
    },
    footer: {
      marginTop: 200,
    },
    containerForm: {
      extend: theme.wrapper,
      marginTop: 300,
    },
    titleForm: {
      fontSize: 67,
      width: '100%',
      textTransform: 'uppercase',
      fontWeight: 500,
      '& strong': {
        fontFamily: theme.fonts[1],
        fontWeight: 400,
      },
    },
    form: {
      width: '71%',
      marginTop: 60,
    },
    anchor: {
      position: 'relative',
      left: 0,
      top: -150,
    },
    containerChi: {
      extend: theme.wrapper,
      marginTop: 300,
    },
  }

  /*------------------------------
  MD
  ------------------------------*/
  output[theme.mediaInverse.md] = {
    titleForm: {
      fontSize: 36,
    },
    form: {
      width: '100%',
    },
  }

  /*------------------------------
  SM
  ------------------------------*/
  output[theme.mediaInverse.sm] = {
    containerForm: {
      marginTop: 150,
    },
    footer: {
      marginTop: 150,
    },
    form: {
      marginTop: 30,
    },
    anchor: {
      position: 'relative',
      left: 0,
      top: -100,
    },
    containerChi: {
      marginTop: 150,
    },
  }

  return output
}

export default style
